import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import React, { memo } from 'react';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';

const TitleDialog = ({ title, handleClose }) => {
    return (
        <>
            <DialogTitle id="alert-dialog-title" sx={{ pb: 0 }}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <Box flex={1} textAlign="center">
                        <Typography variant='h5' fontWeight={700} color={'#1e61b4'}>{title}</Typography>
                    </Box>
                    <Box position="absolute" right={2} top={2}>
                        <IconButton onClick={handleClose}>
                            <DisabledByDefaultIcon sx={{ fontSize: 32 }} color="error" />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
        </>
    )
}

export default memo(TitleDialog);
